import Router from '../Router';
import { HelpController } from '../../controllers';

export default class HelpRouter extends Router {
	constructor(args) {
		super(args);

		this.authOnlyDefault = false;
	}

	initialize(options) {
		this.typeMenu = 'helps';
		this.controller = new HelpController(options);
	}

	authOnly(){
		// Add true if available only for logged players
		return {
			prizes: false
		}
	}

	get appRoutes() {
		return {
			'help': 'help',
			'help/whats-new': 'whatsNew',
			'help/faq': 'faq',
			'help/contact-us': 'contactUs',
			'help/guidelines': 'gameGuidelines',
			'help/prizes': 'prizes',
			'help/terms-and-conditions': 'termsAndConditions',
		};
	}
}